import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (
      command: string,
      targetId: string,
      config?: Record<string, any>
    ) => void;
  }
}

/**
 * Custom hook to track page views with Google Analytics 4
 * Automatically sends a page view event whenever the route changes
 */
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const GA_MEASUREMENT_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

    // Only track if GA is configured and loaded
    if (!GA_MEASUREMENT_ID || !window.gtag) {
      return;
    }

    // Send page view event to Google Analytics
    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.origin + location.pathname + location.search,
    });
  }, [location]);
};

export default usePageTracking;
